var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculadorasIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculadoras-icon",
    transform: "translate(-20 -99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28484",
    "data-name": "Rectangle 28484",
    width: 25,
    height: 25,
    transform: "translate(20 99)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calculate_FILL0_wght400_GRAD0_opsz24",
    d: "M126.01-821.971h1.8v-2.4h2.4v-1.8h-2.4v-2.4h-1.8v2.4h-2.4v1.8h2.4Zm6.01-.9h6.01v-1.8h-6.01Zm0-3h6.01v-1.8h-6.01Zm1.322-4.567,1.683-1.683,1.683,1.683,1.262-1.262-1.683-1.743,1.683-1.683-1.262-1.262-1.683,1.683-1.683-1.683-1.262,1.262,1.683,1.683-1.683,1.743Zm-9.435-2.1h6.01v-1.8h-6.01Zm-1.5,14.183a2.315,2.315,0,0,1-1.7-.706,2.314,2.314,0,0,1-.706-1.7V-837.6a2.315,2.315,0,0,1,.706-1.7,2.315,2.315,0,0,1,1.7-.706h16.827a2.315,2.315,0,0,1,1.7.706,2.315,2.315,0,0,1,.706,1.7v16.827a2.314,2.314,0,0,1-.706,1.7,2.314,2.314,0,0,1-1.7.706Zm0-2.4h16.827V-837.6H122.4Zm0-16.827v0Z",
    transform: "translate(-98 940.999)",
    fill: "#0e426a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadorasIcon);
export default __webpack_public_path__ + "static/media/calculadoras-icon.ee0b880de05f86687f9a0ac9c1120f99.svg";
export { ForwardRef as ReactComponent };